<div class="tabs-container" >
  <ul class="tabs-header" #tabHeader >
    <li
      *ngFor="let tab of tabs"
      (click)="handleSelectTab(tab)"
      [class.cursor]="'pointer'"
      [class.primary-background]="tab?.active"
    >
      <span class="tabs-tab-title" >{{ tab?.title }}</span>
      <span
        *ngIf="tab?.menuItems?.length"
        style="padding: 0px 5px; display: inline-block"
        (click)="handleToggleMenu($event, tab)"
        [style.min-width]="'14px'"
      >
        <i class="fa-solid fa-ellipsis"></i>
      </span>
      <span *ngIf="tab?.canDelete"
        ><button class="tabs-delete-btn" (click)="handleRemoveTab($event, tab)">
          <i
            style="font-size: 10px; padding-right: 10px"
            class="fa-thin fa-xmark"
          ></i></button
      ></span>
    </li>
    <button
      *ngIf="showAddNewTab"
      class="tabs-add-new-tab-btn"
      [disabled]="processingNewTab"
      (click)="handleNewTab($event)"
    >
      <li>
        <i
          style="font-size: 11px"
          *ngIf="!processingNewTab"
          class="fa-solid fa-plus text-link-color"
        ></i>
        <i
          *ngIf="processingNewTab"
          style="font-size: 12px"
          class="fas fa-spinner fa-spin"
        ></i>
      </li>
    </button>
  </ul>
  <div class="tabs-content-wrapper" >
    <ng-content></ng-content>
  </div>
</div>

<div
  class="tabs-menu"
  *ngIf="menuState?.isOpen"
  [ngStyle]="{ top: menuState.top, left: menuState.left }"
>
  <ul>
    <li
      *ngFor="let menuItem of menuState.item?.menuItems"
      (click)="handleMenuItemClicked($event, menuItem)"
    >
      {{ menuItem.label }}
    </li>
  </ul>
</div>
